import { useCallback } from 'react';
import { ANNOTATION_EVENT_NAMES } from '../../../../../analytics/event-name';
import useAnalytics from '../../../../../analytics/useAnalytics';
import { type ToolSelectedPayloadT } from '../../../analytics/types';
const useAnalyticsForToolBar = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventToolSelected = useCallback((payload: ToolSelectedPayloadT) => {
    sendEvent({
      action: ANNOTATION_EVENT_NAMES.TOOL_SELECTED,
      payload
    });
  }, [sendEvent]);
  return {
    sendEventToolSelected
  };
};
export default useAnalyticsForToolBar;